import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EarningModal from "./EarningModal";
import DeductionModal from "./deductionModal";
import OvertimeModal from "./overtimeModal";
import PayroleScaleModel from "./payroleScaleModal";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { fetchPayscales } from "../../../core/data/redux/payroll/payrollComponent/payscale/payscaleActions";
import { fetchEarnings } from "../../../core/data/redux/payroll/payrollComponent/earning/earningActions";
import { fetchDeductions } from "../../../core/data/redux/payroll/payrollComponent/deduction/deductionActions";
import { fetchOvertimePays } from "../../../core/data/redux/payroll/payrollComponent/overtimePayRate/overtimePayActions";
import { formatFullDateTime } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";

const PayRoll = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [tableKey, setTableKey] = useState(0);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
    const [activeTab, setActiveTab] = useState("earning");
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { payscales } = useSelector((state: any) => state.payroll.payrollScall);
    const { earnings } = useSelector((state: any) => state.payroll.earning);
    const { deductions } = useSelector((state: any) => state.payroll.deduction);
    const { overtimePays } = useSelector((state: any) => state.payroll.overtimRate);
    const [selectedFilter, setSelectedFilter] = useState<any>('Recently Added');
    const [payrollScaleData, setPayrollScaleData] = useState({
        RoleId: '',
        SalaryRangeMin: '',
        SalaryRangeMax: '',
        ExperienceLevel: 'Junior',
    });
    const [earningData, setEarningData] = useState({
        Name: '',
        CalculatedUpon: '',
        Percent: null,
        UnitOfCalculation: '',
        Description: '',
        Amount: null,
    });
    const [deductionData, setDeductionData] = useState({
        Name: '',
        CalculatedUpon: '',
        Percent: '',
        Amount: null,
        UnitOfCalculation: '',
        Description: '',
    });
    const [overtimPayData, setOvertimePayData] = useState({
        Name: '',
        RateType: '',
        Rate: '',
    });

    // Permission
    const encryptedPermissions = localStorage.getItem('currentPermissions');
    const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

    const canAdd =
        permissions.includes("Add") || permissions.includes("AllowAll");
    const canView =
        permissions.includes("View") || permissions.includes("AllowAll");
    const canEdit =
        permissions.includes("Edit") || permissions.includes("AllowAll");
    const canDelete =
        permissions.includes("Delete") || permissions.includes("AllowAll");
    const canExport =
        permissions.includes("Export") || permissions.includes("AllowAll");

    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
        setTableKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
        setTableKey(prevKey => prevKey + 1);
    }, [selectedFilter, earnings, overtimePays, deductions, payscales]);

    const handleEditpayrollScaleData = (record: any): void => {
        setSelectedRowData(record);
        setPayrollScaleData({
            RoleId: record.RoleId,
            SalaryRangeMin: record.SalaryRangeMin,
            SalaryRangeMax: record.SalaryRangeMax,
            ExperienceLevel: record.ExperienceLevel || 'Junior',
        });
        showModal('edit');
    };
    const handleEditEarningData = (record: any): void => {
        setSelectedRowData(record);
        setEarningData({
            Name: record.Name,
            CalculatedUpon: record.CalculatedUpon,
            Percent: record.Percent,
            UnitOfCalculation: record.UnitOfCalculation,
            Description: record.Description,
            Amount: record.Amount,
        });
        showModal('edit');
    };
    const handleEditDeductionData = (record: any): void => {
        setSelectedRowData(record);
        setDeductionData({
            Name: record.Name,
            CalculatedUpon: record.CalculatedUpon,
            Percent: record.Percent,
            UnitOfCalculation: record.UnitOfCalculation,
            Description: record.Description,
            Amount: record.Amount
        });
        showModal('edit');
    };
    const handleEditOvertimePayData = (record: any): void => {
        setSelectedRowData(record);
        setOvertimePayData({
            Name: record.Name,
            RateType: record.RateType,
            Rate: record.Rate,
        });
        showModal('edit');
    };

    const showModal = (type: 'edit' | 'create') => {
        setModalType(type);
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setModalType('');
    };
    const config = useAppConfig() ?? {};

    const exportOvertime = overtimePays?.map((value: any) => ({
        "Name": value.Name,
        "RateType": value.RateType,
        "Rate": value.Rate,
        "Created At": formatFullDateTime(value.CreatedAt, config),
        "Modified At": formatFullDateTime(value.ModifiedAt, config),
    }))
    const exportEarnings = earnings?.map((value: any) => ({
        "Earning Name": value.Name,
        "Calculated Upon": value.CalculatedUpon || "None",
        "Percentage (%)": value.Percent ? `${value.Percent}%` : "0%",
        "Amount": value.Amount ?? 0,
        "Description": value.Description || "",
        "Created At": formatFullDateTime(value.CreatedAt, config),
        "Modified At": formatFullDateTime(value.ModifiedAt, config)
    }));

    const exportDeductions = deductions?.map((value: any) => ({
        "Deduction Name": value.Name,
        "Calculated Upon": value.CalculatedUpon || "None",
        "Percentage (%)": value.Percent ? `${value.Percent}%` : "0%",
        "Amount": value.Amount ?? 0,
        "Description": value.Description || "",
        "Created At": formatFullDateTime(value.CreatedAt, config),
        "Modified At": formatFullDateTime(value.ModifiedAt, config)

    }));

    const exportPayScales = payscales?.map((value: any) => ({
        "Role Name": value.RoleName,
        "Experience Level": value.ExperienceLevel || "Junior",
        "Salary Range Min": value.SalaryRangeMin,
        "Salary Range Max": value.SalaryRangeMax,
        "Created At": formatFullDateTime(value.CreatedAt, config),
        "Modified At": formatFullDateTime(value.ModifiedAt, config)
    }));



    const getColumns = () => {
        if (activeTab === 'scale') {
            return [
                {
                    title: "Role ID",
                    dataIndex: "RoleName",
                    render: (text: String) => <h6 className="fs-14 fw-medium text-gray-9">{text}</h6>,
                    sorter: (a: any, b: any) => a.RoleName.length - b.RoleName.length,
                },
                {
                    title: "Experience Level",
                    dataIndex: "ExperienceLabel",
                    sorter: (a: any, b: any) => a.ExperienceLabel.length - b.ExperienceLabel.length,
                },
                {
                    title: "Salary Range Min",
                    dataIndex: "SalaryRangeMin",
                    sorter: (a: any, b: any) => a.SalaryRangeMin - b.SalaryRangeMin,
                },
                {
                    title: "Salary Range Max",
                    dataIndex: "SalaryRangeMax",
                    sorter: (a: any, b: any) => a.SalaryRangeMax - b.SalaryRangeMax,
                },
                {
                    title: "Action",
                    dataIndex: "action",
                    render: (text: String, record: any) => (
                        <div className="action-icon d-inline-flex">
                            <button
                                className="me-2"
                                onClick={() => { if (canEdit) { showModal('edit'); handleEditpayrollScaleData(record) } }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canEdit ? "Edit" : "You do not have permission to edit"}
                                disabled={!canEdit}
                                style={{ cursor: !canEdit ? "not-allowed" : "pointer", opacity: !canEdit ? 0.6 : 1, }}
                            >
                                <i className="ti ti-edit" />
                            </button>
                            <button
                                onClick={() => { if (canDelete) { setSelectedRowData(record); setIsDeleteModalVisible(true); } }}
                                className="me-2" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canDelete ? "Delete" : "You do not have permission to delete"}
                                disabled={!canDelete}
                                style={{ cursor: !canDelete ? "not-allowed" : "pointer", opacity: !canDelete ? 0.6 : 1, }}
                            >
                                <i className="ti ti-trash" />
                            </button>
                        </div>
                    ),
                },
            ];
        }
        if (activeTab === 'earning') {
            return [
                {
                    title: "Earning Name",
                    dataIndex: "Name",
                    render: (text: string) => <h6 className="fs-14 fw-medium text-gray-9">{text}</h6>,
                    sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
                },
                {
                    title: "Calculated Upon",
                    dataIndex: "CalculatedUpon",
                    render: (text: any) => text || "None",
                    sorter: (a: any, b: any) => {
                        const aCalculated = a.CalculatedUpon || '';
                        const bCalculated = b.CalculatedUpon || '';
                        return aCalculated.length - bCalculated.length;
                    },
                },
                {
                    title: "Percentage",
                    dataIndex: "Percent",
                    sorter: (a: any, b: any) => parseFloat(a.Percent ?? "0") - parseFloat(b.Percent ?? "0"),
                    render: (text: string) => {
                        const value = text ?? "0";
                        return <span>{value}%</span>;
                    },
                },
                {
                    title: "Amount",
                    dataIndex: "Amount",
                    sorter: (a: any, b: any) =>
                        parseFloat(a.Amount ?? "0") - parseFloat(b.Amount ?? "0"),
                    render: (text: string | number | null | undefined) => {
                        return <span>{text ?? 0}</span>;
                    }
                },
                {
                    title: "Description",
                    dataIndex: "Description",
                    render: (text: string) => <p className="fs-14 text-gray-6">{text}</p>,
                },
                {
                    title: "Action",
                    dataIndex: "action",
                    render: (text: string, record: any) => (
                        <div className="action-icon d-inline-flex">
                            <button
                                className="me-2"
                                onClick={() => { if (canEdit) { showModal('edit'); handleEditEarningData(record) } }} data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canEdit ? "Edit" : "You do not have permission to Edit"}
                                disabled={!canEdit}
                                style={{ cursor: !canEdit ? "not-allowed" : "pointer", opacity: !canEdit ? 0.6 : 1, }}
                            >
                                <i className="ti ti-edit" />
                            </button>
                            <button
                                onClick={() => { if (canDelete) { setSelectedRowData(record); setIsDeleteModalVisible(true); } }}
                                className="me-2" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canDelete ? "Delete" : "You do not have permission to delete"}
                                disabled={!canDelete}
                                style={{ cursor: !canDelete ? "not-allowed" : "pointer", opacity: !canDelete ? 0.6 : 1, }}
                            >
                                <i className="ti ti-trash" />
                            </button>
                        </div>
                    ),
                },
            ];
        }
        if (activeTab === 'deductions') {
            return [
                {
                    title: "Deduction Name",
                    dataIndex: "Name",
                    render: (text: string) => <h6 className="fs-14 fw-medium text-gray-9">{text}</h6>,
                    sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
                },
                {
                    title: "Calculated Upon",
                    dataIndex: "CalculatedUpon",
                    render: (text: any) => text || "None",
                    sorter: (a: any, b: any) => a.CalculatedUpon.length - b.CalculatedUpon.length,
                },
                {
                    title: "Percentage",
                    dataIndex: "Percent",
                    sorter: (a: any, b: any) => parseFloat(a.Percent ?? "0") - parseFloat(b.Percent ?? "0"),
                    render: (text: string) => {
                        const value = text ?? "0";
                        return <span>{value}%</span>;
                    },
                },
                {
                    title: "Amount",
                    dataIndex: "Amount",
                    sorter: (a: any, b: any) => parseFloat(a.Amount ?? "0") - parseFloat(b.Amount ?? "0"),
                    render: (text: string | number | null | undefined) => {
                        return <span>{text ?? 0}</span>;
                    }
                },
                {
                    title: "Description",
                    dataIndex: "Description",
                    render: (text: string) => <p className="fs-14 text-gray-6">{text}</p>,
                },
                {
                    title: "Action",
                    dataIndex: "action",
                    render: (text: string, record: any) => (
                        <div className="action-icon d-inline-flex">
                            <button
                                className="me-2"
                                onClick={() => { if (canEdit) { showModal('edit'); handleEditDeductionData(record) } }} data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                disabled={!canEdit}
                                title={canEdit ? "Edit" : "You do not have permission to Edit"}
                                style={{ cursor: !canEdit ? "not-allowed" : "pointer", opacity: !canEdit ? 0.6 : 1, }}
                            >
                                <i className="ti ti-edit" />
                            </button>
                            <button
                                onClick={() => { if (canDelete) { setSelectedRowData(record); setIsDeleteModalVisible(true); } }}
                                className="me-2" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canDelete ? "Delete" : "You do not have permission to delete"}
                                disabled={!canDelete}
                                style={{ cursor: !canDelete ? "not-allowed" : "pointer", opacity: !canDelete ? 0.6 : 1, }}
                            >
                                <i className="ti ti-trash" />
                            </button>
                        </div>
                    ),
                },
            ];
        }
        if (activeTab === 'overtime') {
            return [
                {
                    title: "Overtime Name",
                    dataIndex: "Name",
                    render: (text: string) => <h6 className="fs-14 fw-medium text-gray-9">{text}</h6>,
                    sorter: (a: any, b: any) => a.Name.localeCompare(b.Name),
                },
                {
                    title: "Rate Type",
                    dataIndex: "RateType",
                    sorter: (a: any, b: any) => a.RateType.localeCompare(b.RateType),
                },
                {
                    title: "Rate",
                    dataIndex: "Rate",
                    sorter: (a: any, b: any) => parseFloat(a.Rate) - parseFloat(b.Rate),
                    render: (text: string) => <span>{text}</span>,
                },
                {
                    title: "Created At",
                    dataIndex: "CreatedAt",
                    render: (text: string) => <span>{formatFullDateTime(text, config)}</span>, // Format date
                    sorter: (a: any, b: any) => new Date(a.CreatedAt).getTime() - new Date(b.CreatedAt).getTime(),
                },
                {
                    title: "Modified At",
                    dataIndex: "ModifiedAt",
                    render: (text: string) => <span>{formatFullDateTime(text, config)}</span>,  // Format date
                    sorter: (a: any, b: any) => new Date(a.ModifiedAt).getTime() - new Date(b.ModifiedAt).getTime(),
                },
                {
                    title: "Action",
                    dataIndex: "action",
                    render: (text: string, record: any) => (
                        <div className="action-icon d-inline-flex">
                            <button
                                className="me-2"
                                onClick={() => { if (canEdit) { showModal('edit'); handleEditOvertimePayData(record); } }}
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canEdit ? "Edit" : "You do not have permission to Edit"}
                                disabled={!canEdit}
                                style={{ cursor: !canEdit ? "not-allowed" : "pointer", opacity: !canEdit ? 0.6 : 1, }}
                            >
                                <i className="ti ti-edit" />
                            </button>
                            <button
                                onClick={() => { if (canDelete) { setSelectedRowData(record); setIsDeleteModalVisible(true); } }}
                                className="me-2" data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={canDelete ? "Delete" : "You do not have permission to delete"}
                                disabled={!canDelete}
                                style={{ cursor: !canDelete ? "not-allowed" : "pointer", opacity: !canDelete ? 0.6 : 1, }}
                            >
                                <i className="ti ti-trash" />
                            </button>
                        </div>
                    ),
                },
            ];
        }

        // Default columns for other tabs (e.g., earning, overtime, deductions)
        return [
            {
                title: "Name",
                dataIndex: "Name",
                render: (text: String) => <h6 className="fs-14 fw-medium text-gray-9">{text}</h6>,
                sorter: (a: any, b: any) => a.Name.length - b.Name.length,
            },
            {
                title: "Category",
                dataIndex: "Category",
                sorter: (a: any, b: any) => a.Category.length - b.Category.length,
            },
            {
                title: "Default / Unit Amount",
                dataIndex: "Amount",
                sorter: (a: any, b: any) => a.Amount.length - b.Amount.length,
            },
            {
                title: "Action",
                dataIndex: "action",
                render: (text: String, record: any) => (
                    <div className="action-icon d-inline-flex">
                        <button
                            className="me-2"
                            onClick={() => {if(canEdit){ showModal('edit'); handleEditpayrollScaleData(record) }}} data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={canEdit ? "Edit" : "You do not have permission to Edit"}
                            disabled={!canEdit}
                            style={{ cursor: !canEdit ? "not-allowed" : "pointer", opacity: !canEdit ? 0.6 : 1, }}
                        >
                            <i className="ti ti-edit" />
                        </button>
                        <Link to="#" data-bs-toggle="modal" data-bs-target="#delete_modal"
                            data-bs-placement="top"
                            title="Delete">
                            <i className="ti ti-trash" />
                        </Link>
                    </div>
                ),
            },
        ];
    };

    const getTableData = () => {
        let data = [];
        switch (activeTab) {
            case "earning":
                data = earnings;
                break;
            case "overtime":
                data = overtimePays;
                break;
            case "deductions":
                data = deductions;
                break;
            case "scale":
                data = payscales;
                break;
            default:
                data = earnings;
                break;
        }
        return filterData(data, {}, "CreatedAt", "CreatedAt", selectedFilter);
    };

    const getTitle = () => {
        switch (activeTab) {
            case "earning":
                return "Earning List";
            case "overtime":
                return "Overtime List";
            case "deductions":
                return "Deductions List";
            case "scale":
                return "Pay Scale List";
            default:
                return "Earning List";
        }
    };

    const exportByType = (type: string, data: any[], name: string) => {
    if (type === "csv") return exportToCSV(data, name);
    if (type === "excel") return exportToExcel(data, name);
    if (type === "pdf") return exportToPDF(data, name);
};


    const handleExport = (type: 'csv' | 'excel' | 'pdf') => {
    switch (activeTab) {
        case "earning":
            exportByType(type, exportEarnings, "earning_data");
            break;

        case "overtime":
            exportByType(type, exportOvertime, "overtime_rate_data");
            break;

        case "deductions":
            exportByType(type, exportDeductions, "deductions_data");
            break;

        case "scale":
            exportByType(type, exportPayScales, "payscales_data");
            break;

        default:
            exportByType(type, exportEarnings, "earning_data");
            break;
    }
};

    const handleSortChange = (sortOption: any) => {
        setSelectedFilter(sortOption);
    };


    useEffect(() => {
        if (payscales?.length === 0 && activeTab === 'scale') {
            dispatch(fetchPayscales());
        }
        if (earnings?.length === 0 && activeTab === 'earning') {
            dispatch(fetchEarnings());
        }
        if (deductions?.length === 0 && activeTab === 'deductions') {
            dispatch(fetchDeductions());
        }
        if (overtimePays?.length === 0 && activeTab === 'overtime') {
            dispatch(fetchOvertimePays())
        }
    }, [dispatch, payscales?.length, earnings?.length, deductions?.length, overtimePays?.length, activeTab]);

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                {/* Content */}
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">{getTitle()}</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Payroll</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {getTitle()}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {canExport && (
                                <div className="me-2 mb-2">
                                    <div className="dropdown">
                                        <Link
                                            to="#"
                                            className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                            data-bs-toggle="dropdown"
                                        >
                                            <i className="ti ti-file-export me-1" />
                                            Export
                                        </Link>
                                        <ul className="dropdown-menu  dropdown-menu-end p-3">
                                            <li>
                                                <button
                                                    onClick={() => handleExport('csv')}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-pdf me-1" />
                                                    Export as CSV
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => handleExport('excel')}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as Excel{" "}
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => handleExport('pdf')}
                                                    className="dropdown-item rounded-1"
                                                >
                                                    <i className="ti ti-file-type-xls me-1" />
                                                    Export as PDF{" "}
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            )}
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>

                    {/* Tab Selection */}
                    <div className="d-flex flex-wrap gy-2 justify-content-between my-4">
                        <div className="payroll-btns">
                            <Link to="#" onClick={() => handleTabClick("earning")} className={`btn btn-white ${activeTab === 'earning' ? 'active' : ''} border me-2`}>Earning</Link>
                            <Link to="#" onClick={() => handleTabClick("overtime")} className={`btn btn-white ${activeTab === 'overtime' ? 'active' : ''} border me-2`}>Overtime</Link>
                            <Link to="#" onClick={() => handleTabClick("deductions")} className={`btn btn-white ${activeTab === 'deductions' ? 'active' : ''} border me-2`}>Deductions</Link>
                            <Link to="#" onClick={() => handleTabClick("scale")} className={`btn btn-white ${activeTab === 'scale' ? 'active' : ''} border`}>Pay Scale</Link>
                        </div>
                        <div className="mb-2">
                            {canAdd && (
                                <button
                                    onClick={() => showModal('create')}
                                    className="btn btn-primary d-flex align-items-center"
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add {getTitle()}
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Payroll List */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>{getTitle()}</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        Sort By : {selectedFilter}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                                onClick={() => handleSortChange('Last 7 Days')}
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                                onClick={() => handleSortChange('Recently Added')}
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                                onClick={() => handleSortChange('Ascending')}
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                className="dropdown-item rounded-1"
                                                onClick={() => handleSortChange('Descending')}
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table key={tableKey} dataSource={getTableData()} columns={getColumns()} Selection={true} />
                        </div>
                    </div>
                    {/* /Payroll List */}
                </div>
                {/* Footer */}
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* Modals */}
            {activeTab === 'earning' && (
                <EarningModal handleCancel={handleCancel} isModalVisible={isModalVisible} modalType={modalType} selectedRowData={selectedRowData} earningData={earningData} setEarningData={setEarningData} setTableKey={setTableKey} setIsDeleteModalVisible={setIsDeleteModalVisible} isDeleteModalVisible={isDeleteModalVisible} />
            )}
            {activeTab === 'deductions' && (
                <DeductionModal handleCancel={handleCancel} isModalVisible={isModalVisible} modalType={modalType} selectedRowData={selectedRowData} deductionData={deductionData} setDeductionData={setDeductionData} setTableKey={setTableKey} setIsDeleteModalVisible={setIsDeleteModalVisible} isDeleteModalVisible={isDeleteModalVisible} />
            )}
            {activeTab === 'overtime' && (
                <OvertimeModal handleCancel={handleCancel} isModalVisible={isModalVisible} modalType={modalType} selectedRowData={selectedRowData} overtimPayData={overtimPayData} setOvertimePayData={setOvertimePayData} setTableKey={setTableKey} setIsDeleteModalVisible={setIsDeleteModalVisible} isDeleteModalVisible={isDeleteModalVisible} />
            )}
            {activeTab === 'scale' && (
                <PayroleScaleModel handleCancel={handleCancel} isModalVisible={isModalVisible} modalType={modalType} selectedRowData={selectedRowData} payrollScaleData={payrollScaleData} setPayrollScaleData={setPayrollScaleData} setTableKey={setTableKey} setIsDeleteModalVisible={setIsDeleteModalVisible} isDeleteModalVisible={isDeleteModalVisible} />
            )}
        </>
    );
};

export default PayRoll;
